import { render, staticRenderFns } from "./weightage_modal.vue?vue&type=template&id=e3c59dc2&"
import script from "./weightage_modal.vue?vue&type=script&lang=js&"
export * from "./weightage_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports